<template lang="html">
  <div class="page-admin">
    <div class="row">
      <card-component
       :block="false" title="Pedidos deste cliente" subtitle="" :col="{xs: 12}"
        idCollapse="followUpListCollapse"
      >
        <follow-up-order-list-component :cpf="tx.data.data.buyer.cpf" :showCollapse="false" idCollapse="followUpListCollapse"></follow-up-order-list-component>
      </card-component>
      <card-component v-if="isBlacklist">
        <blacklist-component :blacklistData="blacklistData"></blacklist-component>
      </card-component>
      <card-component :col="{md: 6, xs: 12}">
        <tags-component></tags-component>
        <user-campaigns-list></user-campaigns-list>
        <transaction-details-component :tx="tx.tx"></transaction-details-component>
      </card-component>
      <card-component :col="{md: 6, xs: 12}">
        <user-details-component :user="tx.data.data.buyer" :tx="tx.tx" :reference="tx.data.data.reference" :shipping="tx.data.data.shipping" :validation="tx.validation"></user-details-component>
      </card-component>
      <card-component :col="{md: 6, xs: 12}">
        <order-details-component :cart="tx.data.data.cart" :reference="tx.data.data.reference" :payment="tx.data.data.payment" :shipping="tx.data.data.shipping" :sellerStatus="tx.tx.sellerStatus" :cartUrl="tx.tx.cartUrl"></order-details-component>
      </card-component>
      <card-component :col="{md: 6, xs: 12}">
        <loan-details-component :ccb="tx.ccb" :txuuid="this.$route.params.txid"></loan-details-component>
      </card-component>
      <card-component :col="{xs: 12}">
        <div class="card-inner">
          <h3>Timeline de atividades</h3>
          <div class="container py-2">
            <timeline-component :timeline="timeline"/>
          </div>
        </div>
      </card-component>
      <card-component :col="{xs: 12, md: 6}">
        <button-component :nolink="true" @click.native="sendSms" class='btn-danger' :disable="true">
          Enviar lembrete de cobrança por SMS
        </button-component>
        <div>{{ retornoSms }}</div>
      </card-component>
      <card-component :col="{xs: 12, md: 6}">
        <lottie-component v-if="loadingCancel"
                          :options="loadingOptions"
                          :height="200"
                          :width="200" />
        <div v-else>
          <button-component :nolink="true" @click.native="cancelTransaction" class='btn-danger' :disable="true">
            Cancelar CCB e boletos
          </button-component>
        </div>
      </card-component>
    </div>
  </div>
</template>

<script>
import Card from '../../partial/card/Card.vue'
import Navbar from '../../partial/navbar/Navbar.vue'
import Dashboard from '../../partial/dashboard/Dashboard.vue'
import Background from '../../partial/background/Background.vue'
import Input from '../../partial/form/Input.vue'
import Button from '../../partial/button/Button.vue'
import Timeline from '../../partial/timeline/Timeline.vue'
import FollowUpOrderList from '../../partial/customerservice/FollowUpOrderList'
import UserDetails from '../../partial/cards/users/UserDetails'
import OrderDetails from '../../partial/cards/order/OrderDetails'
import TransactionDetails from '../../partial/cards/transactions/TransactionDetails'
import LoanDetails from '../../partial/cards/loans/LoanDetails'
import animationLoading from '../../../assets/animation/loading.json'
import Lottie from 'vue-lottie'
import BlacklistDetail from '../../partial/cards/blacklist/BlacklistDetails'
import Tags from '../../partial/tags/Tags'
import UserCampaignsList from '../../partial/tagCampaigns/UserCampaignsList'

export default {
  components: {
    'card-component': Card,
    'navbar-component': Navbar,
    'dashboard-component': Dashboard,
    'background-component': Background,
    'button-component': Button,
    'input-component': Input,
    'timeline-component': Timeline,
    'follow-up-order-list-component': FollowUpOrderList,
    'user-details-component': UserDetails,
    'transaction-details-component': TransactionDetails,
    'order-details-component': OrderDetails,
    'loan-details-component': LoanDetails,
    'lottie-component': Lottie,
    'blacklist-component': BlacklistDetail,
    'tags-component': Tags,
    'user-campaigns-list': UserCampaignsList
  },
  data () {
    return {
      isBlacklist: undefined,
      blacklistData: null,
      tx: null,
      timeline: null,
      // interval: null,
      refreshList: null,
      orderList: null,
      stepList: null,
      retornoSms: null,
      loadingCancel: false,
      loadingOptions: { animationData: animationLoading, loop: true }
    }
  },
  methods: {
    getBlacklist () {
      this.$http.get('api/blacklist?cpf=' + this.tx.data.data.buyer.cpf)
        .then(function (res) {
          this.isBlacklist = res.data.list[0].isBlacklist
          this.blacklistData = res.data.list
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
    },
    getTransaction () {
      this.$http.get('api/transactions/' + this.$route.params.txid)
        .then(function (res) {
          this.tx = res.data
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        }).then(function () {
          this.getBlacklist()
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
    },
    getTimeline () {
      this.$http.get('api/transactions/' + this.$route.params.txid + '/timeline')
        .then(function (res) {
          this.timeline = res.data
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
    },
    fetchData () {
      this.getTransaction()
      this.getTimeline()
    },
    sendSms () {
      this.$http.post('api/transactions/' + this.$route.params.txid + '/sendSms')
        .then(function (res) {
          this.retornoSms = res.data
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
          this.retornoSms = res.data
        })
    },
    selecionouOpcao (value) {
      this.orderList = value
      this.refreshList = (this.refreshList === null) ? true : !this.refreshList
    },
    selecionouOpcao2 (value) {
      this.stepList = value
      this.refreshList = (this.refreshList === null) ? true : !this.refreshList
    },
    cancelTransaction (fdic) {
      this.$bvModal.msgBoxConfirm('Você confirma o CANCELAMENTO deste pedido?', {
        title: 'CANCELAMENTO',
        size: 'sm',
        okVariant: 'success',
        okTitle: 'SIM, cancelar pedido',
        cancelTitle: 'Não',
        footerClass: 'p-2',
        hideHeaderClose: false
      })
        .then(value => {
          if (value === true) {
            this.loadingCancel = true
            this.$http.post('api/validations/' + this.$route.params.txid + '/cancel')
              .then(function (res) {
                this.loadingCancel = false
                this.$bvToast.toast(res.data, {
                  title: 'Cancelamento de pedido',
                  autoHideDelay: 5000,
                  variant: 'primary'
                })
                this.fetchData()
              })
              .catch(function (res) {
                console.log('Error')
                console.log(res)
                this.loadingCancel = false
                this.$bvToast.toast(res.data, {
                  title: 'Cancelamento de pedido',
                  autoHideDelay: 5000,
                  variant: 'danger'
                })
              })
          }
        })
        .catch(err => {
          console.log('Error: ' + err)
        })
    }
  },
  mounted () {
    this.fetchData()
  },
  watch: {
    '$route.params.txid' () {
      this.fetchData()
    }
  },
  beforeDestroy: function () {
    // clearInterval(this.interval)
  }
}

</script>

<style lang="scss" scoped>
  @import "../../../assets/scss/variaveis.scss";
  @import "../../../assets/scss/card.scss";
  h3 {
    padding-top: 15px;
    padding-bottom: 10px;
    font-size: 22px;
    font-family: "Poppins", sans-serif;
    color: #6E6E6E;
    font-weight: 400;
  }
  .form-label {
    color: #C0C0C0;
    font-size: 14px;
    line-height: 1.2em;
    margin-bottom: 0;
  }
  .form-control-plaintext {
    color: #6E6E6E;
    font-size: 18px;
    padding-top: 0;
  }
  .card-inner {
    padding-left: 50px;
    padding-right: 50px;
    padding-top: 5px;
  }
  .document-image {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/customerservice/CustomerServiceDetailsNew.vue